import * as React from 'react';
import { DisplaySectionFieldType } from '../../types/components';
import { FIELD_TYPES_BY_NAME } from '../../constants/enums';
import { parseIconToken } from '../../services/utilityFunctions';

const DisplaySectionField = ({ field }: { field: DisplaySectionFieldType }) => {
  if (field.type === FIELD_TYPES_BY_NAME.HORIZONTAL_RULE) {
    return <hr className="small" />
  }

  if (field.type === FIELD_TYPES_BY_NAME.ICON_MULTILINE_TEXT) {
    // formattedValue is untyped API data: a null value blanks the row, like every other branch
    const display = field.formattedValue ?? "";

    // icon renders on whichever side of the text the {icon:…} token sits
    const { iconUrl, text, isIconFirst } = parseIconToken(display);
    const hasIcon = iconUrl !== undefined;
    const showIconFirst = hasIcon && isIconFirst;
    const showIconLast = hasIcon && !isIconFirst;

    return (
      <div className="flex-row">
        <div>
          <p className="value text-primary display-section__icon-text">
            {showIconFirst && <img className="display-section__icon" src={iconUrl} alt="" aria-hidden />}
            <span dangerouslySetInnerHTML={{ __html: text }} />
            {showIconLast && <img className="display-section__icon" src={iconUrl} alt="" aria-hidden />}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-row">
      {field.label &&
        <div>
          <label>
            <span dangerouslySetInnerHTML={{ __html: field.label }} />
            {field.superscript &&
              <sup>{field.superscript}</sup>
            }
          </label>
        </div>
      }
      {/* If field does not have formattedValue, then label should take up 100% width */}
      <div className={`${field.label ? "text-right" : ""}`}>
        <p className={`value ${!field.label ? "text-primary" : ""}`} dangerouslySetInnerHTML={{ __html: field.formattedValue }} ></p>
      </div>
    </div>
  );
}

export default DisplaySectionField;